export default __webpack_public_path__ + "static/media/electron.2ae17ce2.svg";